import styled, { css } from "styled-components";

import { DESKTOP_BREAKPOINT } from "../../../../../../components/AppShell/styles";

/* Five per row, inside the Temas prontos group's card */
export const ThemeCardsSection = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 16px;

  /* Phones: the 9 themes 3 by 3 */
  @media not all and (min-width: ${DESKTOP_BREAKPOINT}) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px;
  }
`;

type ThemeCardProps = {
  $active: boolean;
  $primary: string;
  $secondary: string;
};

export const ThemeCard = styled.div.attrs<ThemeCardProps>(props => ({
  role: "button",
  $active: props.$active,
  $primary: props.$primary,
  $secondary: props.$secondary,
  style: {
    backgroundColor: props.$primary,
    color: props.$secondary,
  },
}))`
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 1.125rem;
  line-height: 1.5rem;
  border-radius: 12px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  /* a thin light edge: a dark theme (the card's own color) still shows its shape */
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.16);

  /* "Redefinir": icon and word, smaller than the "Ab" samples */
  ${props =>
    props.$active &&
    css`
      &:before {
        content: "";
        position: absolute;
        display: block;
        border: 3px solid var(--color-brand-blue);
        width: calc(100% + 6px);
        height: 52px;
        border-radius: 15px;
      }
    `}
`;
